import "./accordion.css";

import Accordion from "react-bootstrap/Accordion";
import { Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { useEffect, useRef, useState } from "react";

import useStore from "stores/Store";
import { LinkButton } from "components/buttons";
import { formatTitleWithItalic } from "utils";

function AccordionSimple({
  setAccordionState,
  data,
  toggleButton,
  viewAllButton,
}) {
  const navigate = useNavigate();
  const { setFaqRef } = useStore();
  const ref = useRef(null);

  const [activeKeys, setActiveKeys] = useState([]);
  const [toggle, setToggle] = useState(true);
  const [viewMore, setViewMore] = useState(false);
  const itemsToShow = viewMore ? data : data.slice(0, 8);


  const toggleAll = (expand) => {
    if (expand) {
      setActiveKeys(data.map((_, index) => index.toString()));
      setToggle(false);
    } else {
      setToggle(true);
      setActiveKeys([]);
    }
  };

  const handleSelect = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  useEffect(() => {
    if (activeKeys.length === data.length) {
      setToggle(false);
    } else {
      setToggle(true);
    }
  }, [activeKeys]);

  useEffect(() => {
    setFaqRef(ref);
  }, []);

  return (
    <>
      {toggleButton && (
        <div className="mb-2 d-flex justify-end">
          {toggle ? (
            <span className="toggle-button" onClick={() => toggleAll(true)}>
              Expand all
            </span>
          ) : (
            <span className="toggle-button" onClick={() => toggleAll(false)}>
              Collapse all
            </span>
          )}
        </div>
      )}
      <Accordion
        id="accordion-simple"
        activeKey={activeKeys}
        onSelect={handleSelect}
        data-aos="fade-down"
        ref={ref}
      >
        {itemsToShow.map((item, index) => (
           <Accordion.Item key={index} className="accordion-item-wrapper" eventKey={index.toString()}>
                <Accordion.Header>
                  <div className="d-inline-flex align-items-center">
                    {item?.title && (
                      <h5 className="mb-0">{formatTitleWithItalic(parse(item?.title))}</h5>
                    )}
                  </div>
                </Accordion.Header>
                {item?.content && (
                  <Accordion.Body>{parse(item?.content)}</Accordion.Body>
                )}
              </Accordion.Item>
        ))}
      </Accordion>
      {/* <Accordion
        id="accordion-simple"
        activeKey={activeKeys}
        onSelect={handleSelect}
        data-aos="fade-down"
        ref={ref}
      >
        {viewMore
          ? data.map((item, index) => (
              <Accordion.Item key={index} eventKey={index.toString()}>
                <Accordion.Header>
                  <div className="d-inline-flex align-items-center">
                    {item?.title && (
                      <h5 className="mb-0">{parse(item?.title)}</h5>
                    )}
                  </div>
                </Accordion.Header>
                {item?.content && (
                  <Accordion.Body>{parse(item?.content)}</Accordion.Body>
                )}
              </Accordion.Item>
            ))
          : data.slice(0, 8).map((item, index) => (
              <Accordion.Item key={index} eventKey={index.toString()}>
                <Accordion.Header>
                  <div className="d-inline-flex align-items-center">
                    {item?.title && (
                      <h5 className="mb-0">{parse(item?.title)}</h5>
                    )}
                  </div>
                </Accordion.Header>
                {item?.content && (
                  <Accordion.Body>{parse(item?.content)}</Accordion.Body>
                )}
              </Accordion.Item>
            ))}
      </Accordion> */}

      {viewAllButton &&
        (!viewMore ? (
          <div className="d-flex justify-content-center my-5">
            <LinkButton
              text="View all FAQ"
              onClick={() => setViewMore(true)}
            ></LinkButton>
          </div>
        ) : (
          <div className="d-flex justify-content-center my-5">
            <LinkButton
              text="View fewer FAQ"
              onClick={() => {
                setViewMore(false);
                window.scrollTo({
                  top: ref.current.offsetTop - 400,
                  behavior: "smooth",
                });
              }}
            ></LinkButton>
          </div>
        ))}
    </>
  );
}

export default AccordionSimple;
